import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyC0usVmkz8Qm3U0ZbXL3S5Uh4FQ0kr1XtA",
    authDomain: "q8auctionapp-2c6dd.firebaseapp.com",
    projectId: "q8auctionapp-2c6dd",
    storageBucket: "q8auctionapp-2c6dd.firebasestorage.app",
    messagingSenderId: "662295000181",
    appId: "1:662295000181:web:ca430ffcd4ca0ab813b43c",
   
};
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);